import React from 'react'
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import SignupPage from '../containers/SignupPage'
import SigninPage from '../containers/SigninPage'
import NoteListPage from '../containers/NoteListPage'
import Signout from '../containers/Signout'
import Welcome from '../components/Welcome'
import NoteCreationPage from '../containers/NoteCreationPage'
import NoteEditionPage from '../containers/NoteEditionPage'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import LockIcon from 'material-ui-icons/Lock'
import {
  withStyles,
  MuiThemeProvider,
  createMuiTheme
} from 'material-ui/styles'
import blueGrey from 'material-ui/colors/blueGrey'

const styles = theme => ({
  root: {
    marginTop: 0,
    width: '100%'
  },
  flex: {
    flex: 1
  },
  menuButton: {
    marginLeft: -1.5 * theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  appTitle: {
    color: 'inherit',
    textDecoration: 'none'
  }
})

const theme = createMuiTheme({
  palette: {
    primary: blueGrey
  }
})

export default withStyles(styles)(({ classes, user }) => (
  <Router>
    <MuiThemeProvider theme={theme}>
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              className={classes.menuButton}
              color="contrast"
              aria-label="Menu"
            >
              <LockIcon />
            </IconButton>
            <Typography type="title" color="inherit" className={classes.flex}>
              <Link to="/" className={classes.appTitle}>
                SecNotes
              </Link>
            </Typography>
            {!user && (
              <Button color="contrast" component={Link} to="/signup">
                Sign up
              </Button>
            )}
            {!user && (
              <Button color="contrast" component={Link} to="/signin">
                Sign in
              </Button>
            )}
            {user && (
              <Button color="contrast" component={Link} to="/notes">
                My notes
              </Button>
            )}
            {user && (
              <Button color="contrast" component={Link} to="/signout">
                Sign out
              </Button>
            )}
          </Toolbar>
        </AppBar>

        <Route exact path="/" component={Welcome} />
        <Route exact path="/notes" component={NoteListPage} />
        <Route exact path="/create-note" component={NoteCreationPage} />
        <Route path="/notes/:noteId" component={NoteEditionPage} />
        <Route exact path="/signup" component={SignupPage} />
        <Route exact path="/signin" component={SigninPage} />
        <Route exact path="/signout" component={Signout} />
      </div>
    </MuiThemeProvider>
  </Router>
))



// WEBPACK FOOTER //
// ./src/components/AppRouter.js